import type { TextFieldProps } from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import type { ReactNode } from 'react';
import { forwardRef } from 'react';

import { AdornmentsContainer, PostfixContainer } from './styles';

const DateTextField = (postfixEl: ReactNode) =>
  forwardRef<HTMLDivElement, TextFieldProps>(
    function TextFieldWithPostfix(props, ref) {
      const { InputProps, ...rest } = props || {};

      const endAdornment = InputProps?.endAdornment;
      const mergedEndAdornment = (
        <AdornmentsContainer>
          {endAdornment}
          {postfixEl ? <PostfixContainer>{postfixEl}</PostfixContainer> : null}
        </AdornmentsContainer>
      );

      return (
        <TextField
          {...(rest as any)}
          ref={ref as any}
          InputProps={{
            ...(InputProps || {}),
            endAdornment: mergedEndAdornment,
          }}
        />
      );
    },
  );

export default DateTextField;
